// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eaptype-modal {
  width: 97%;
  position: absolute;
  left: 0;
  right: 0;
  top: 36px;
  background: #d3e2ed;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/eap-type/eap-type-view/eap-type-view.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AACJ","sourcesContent":[".eaptype-modal{\r\n    width: 97%;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 36px;\r\n    background: #d3e2ed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
